/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      this.handleScrollTheme = this.handleScrollTheme.bind(this);
      this._scrollThemeBound = false;
      this.flkty = null;
    }

    connectedCallback() {
      const slideshow = this;

      let
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
        align = slideshow.dataset.align == 'center' ? 'center' : 'left',
        fade = slideshow.dataset.fade == 'true' ? true : false,
        pageDots = slideshow.dataset.dots == 'true' ? true : false,
        prev_buttons = slideshow.querySelectorAll('.flickity-prev'),
        next_buttons = slideshow.querySelectorAll('.flickity-next'),
        header = document.querySelector('theme-header'),
        custom_dots = slideshow.querySelector('.flickity-dots'),
        autoplay_progress = slideshow.querySelector('.slideshow--autoplay-progress'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar:not(.slideshow--autoplay-progress)'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
        args = {
          wrapAround: true,
          cellAlign: align,
          pageDots: pageDots,
          contain: true,
          fade: fade,
          autoPlay: autoplay,
          rightToLeft: rightToLeft,
          prevNextButtons: false,
          cellSelector: '.carousel__slide',
          on: {}
        };

      this.paused = false;

      if (custom_dots) {
        args.pageDots = false;
        args.pauseAutoPlayOnHover = false;
      }

      if (slideshow.dataset.adapt == 'true') {
        args.adaptiveHeight = true;
      }

      if (slideshow.classList.contains('customer-reviews--carousel')) {
        args.wrapAround = true;
        args.resize = true;
      }

      if (
        slideshow.classList.contains('collection-grid__carousel') ||
        slideshow.classList.contains('product-images-quick-view')
      ) {
        args.wrapAround = false;
      }

      // Main Slideshow
      if (slideshow.classList.contains('main-slideshow')) {
        if (animations_enabled) {
          slideshow.prepareAnimations(slideshow, animations);
        }

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },

          ready: function () {
            let flkty = this;

            // Transparent Header padding
            if (header?.classList.contains('transparent--true')) {
              let i = slideshow.dataset.sectionIndex;

              if (Shopify.designMode) {
                let children = [...slideshow.closest('.shopify-section').parentNode.children];
                i = children.indexOf(slideshow.closest('.shopify-section')) + 1;
              }

              if (i == 1 && slideshow.classList.contains('section-spacing--disable-top')) {
                slideshow.classList.add('slideshow--top');
              }
            }

            // 初始化时同步当前 slide 主题
            slideshow.updateHeaderTheme(this.selectedElement);
            slideshow.bindHeaderThemeScroll();

            // Animations
            if (animations_enabled) {
              slideshow.animateSlides(0, slideshow, animations);
            }

            // Fonts resize
            document.fonts.ready.then(function () {
              flkty.resize();
            });

            // Video Support
            let video_container = flkty.cells[0]?.element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () {
                  slideshow.videoPlay(video_container);
                };
              }
            }

            // Custom Dots
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.addEventListener('click', () => {
                  flkty.select(i);
                });
              });

              if (dots[this.selectedIndex]) {
                dots[this.selectedIndex].classList.add('is-selected');
              }
            }
          },

          change: function (index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Animations
            if (animations_enabled) {
              slideshow.animateReverse(previousIndex, slideshow, animations);
              slideshow.animateSlides(index, slideshow, animations);
            }

            // Color changes
            let color_text = getComputedStyle(this.selectedElement).getPropertyValue('--color-text'),
              color_text_rgb = getComputedStyle(this.selectedElement).getPropertyValue('--color-text-rgb');

            slideshow.style.setProperty('--color-text', color_text);
            slideshow.style.setProperty('--color-text-rgb', color_text_rgb);

            // 当前 slide 主题同步
            slideshow.updateHeaderTheme(this.selectedElement);


            // AutoPlay reset
            if (autoplay && flkty.player && flkty.player.state !== 'paused') {
              flkty.stopPlayer();
              flkty.playPlayer();
            }

            // Video Support
            let video_container_prev = flkty.cells[previousIndex]?.element.querySelector('.slideshow__slide-video-bg');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }

            let video_container = flkty.cells[index]?.element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                const iframe = video_container.querySelector('iframe');

                if (iframe.classList.contains('lazyload')) {
                  iframe.addEventListener(
                    'lazybeforeunveil',
                    () => {
                      slideshow.videoPlay(video_container);
                    },
                    { once: true }
                  );

                  if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
                    lazySizes.loader.checkElems();
                  }
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }

            // Custom Dots
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot) => {
                dot.classList.remove('is-selected');
              });

              if (dots[this.selectedIndex]) {
                dots[this.selectedIndex].classList.add('is-selected');
              }
            }
          }
        };

        if (
          slideshow.classList.contains('desktop-height-image') ||
          slideshow.classList.contains('mobile-height-image')
        ) {
          args.adaptiveHeight = true;
        }
      }

      // Testimonials
      if (slideshow.classList.contains('testimonials--carousel')) {
        args.on = {
          ready: function () {
            let flkty = this;

            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.addEventListener('click', () => {
                  flkty.select(i);
                });
              });

              if (dots[this.selectedIndex]) {
                dots[this.selectedIndex].classList.add('is-selected');
              }
            }

            if (autoplay && autoplay_progress) {
              slideshow.setupAutoplayProgress(slideshow, autoplay_progress);
            }
          },

          change: function () {
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot) => {
                dot.classList.remove('is-selected');
              });

              if (dots[this.selectedIndex]) {
                dots[this.selectedIndex].classList.add('is-selected');
              }
            }

            if (autoplay && autoplay_progress && slideshow.autoPlayProgressTL) {
              slideshow.autoPlayProgressTL.progress(0);

              if (this.player && this.player.state !== 'paused') {
                slideshow.autoPlayProgressTL.play();
              }
            }
          }
        };
      }

      // Product Carousels
      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on.ready = function () {
          let flickity = this;
          if (next_buttons.length) {
            window.addEventListener('resize.center_arrows', function () {
              slideshow.centerArrows(flickity, slideshow, prev_buttons[0], next_buttons[0]);
            });
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }

      if (progress_bar) {
        args.wrapAround = false;
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          progress_bar.style.width = progress * 100 + '%';
        };
      }

      // Recommendation cards have their own links/buttons. Focusing the whole
      // track makes some screen readers announce every product in the carousel.
      const recommendationCarousel = slideshow.classList.contains('product-recommendations--products');
      const mainSlideshow = slideshow.classList.contains('main-slideshow');
      const announcementCarousel = slideshow.dataset.announcementCarousel === 'true';
      if (recommendationCarousel || mainSlideshow || announcementCarousel) args.accessibility = false;

      // Initiate
      const flkty = new Flickity(slideshow, args);
      this.flkty = flkty;
      // Banner overlay links must also be reachable only on the visible slide.
      if (recommendationCarousel || mainSlideshow || announcementCarousel) {
        const updateAccessibleSlides = () => {
          const selected = new Set(flkty.selectedElements || []);
          const focusedSlide = document.activeElement?.closest('.carousel__slide');
          for (const cell of flkty.cells) {
            const active = selected.has(cell.element);
            cell.element.inert = !active;
            cell.element.setAttribute('aria-hidden', String(!active));
          }
          // A swipe or programmatic change can hide the currently focused card.
          if (focusedSlide && slideshow.contains(focusedSlide) && !selected.has(focusedSlide)) {
            flkty.selectedElement?.querySelector('a[href], button:not(:disabled)')?.focus({ preventScroll: true });
          }
        };
        flkty.on('select', updateAccessibleSlides);
        updateAccessibleSlides();
        this.cleanupRecommendationAccessibility = () => {
          flkty.off('select', updateAccessibleSlides);
          flkty.cells.forEach(({ element }) => { element.inert = false; });
        };
      }

      if (announcementCarousel && autoplay) {
        // Stop rather than pause so mouseleave cannot resume while focus is inside.
        const stopOnFocus = () => flkty.stopPlayer();
        const resumeOnBlur = (event) => {
          if (slideshow.contains(event.relatedTarget)) return;
          flkty.playPlayer();
          if (slideshow.matches(':hover')) flkty.pausePlayer();
        };
        slideshow.addEventListener('focusin', stopOnFocus);
        slideshow.addEventListener('focusout', resumeOnBlur);
        if (slideshow.contains(document.activeElement)) stopOnFocus();
        this.cleanupAnnouncementPlayback = () => {
          slideshow.removeEventListener('focusin', stopOnFocus);
          slideshow.removeEventListener('focusout', resumeOnBlur);
        };
      }

      if (mainSlideshow) {
        if (custom_dots) slideshow.appendChild(custom_dots);
        const syncDotButtons = () => {
          const dots = custom_dots?.querySelectorAll('li') || flkty.pageDots?.dots || [];
          dots.forEach((dot, index) => {
            let button = dot.querySelector('.slideshow-dot-button');
            if (!button) {
              button = document.createElement('button');
              button.type = 'button';
              button.className = 'slideshow-dot-button';
              button.addEventListener('click', (event) => {
                event.stopPropagation();
                flkty.uiChange();
                flkty.select(index);
              });
              dot.appendChild(button);
            }
            const slide = flkty.slides[index]?.getCellElements()[0];
            const heading = slide?.querySelector('.slideshow__slide-heading')?.textContent.trim();
            button.setAttribute('aria-label', heading || dot.textContent.trim() || String(index + 1));
            button.setAttribute('aria-current', String(index === flkty.selectedIndex));
            dot.removeAttribute('aria-label');
            dot.removeAttribute('aria-current');
          });
        };
        // Keep the selected slide stable while a keyboard user operates it.
        const stopOnFocus = () => flkty.stopPlayer();
        slideshow.addEventListener('focusin', stopOnFocus);
        flkty.on('select', syncDotButtons);
        flkty.on('cellChange', syncDotButtons);
        syncDotButtons();
        this.cleanupBannerDots = () => {
          slideshow.removeEventListener('focusin', stopOnFocus);
          flkty.off('select', syncDotButtons);
          flkty.off('cellChange', syncDotButtons);
        };
      }

      slideshow.dataset.initiated = true;

      // Arrows
      if (prev_buttons) {
        prev_buttons.forEach(function (prev_button) {
          prev_button.addEventListener('click', () => {
            document.dir === 'rtl' ? flkty.next() : flkty.previous();
          });
          prev_button.addEventListener('keyup', (event) => {
            if (prev_button.tagName === 'BUTTON' || !['Enter', ' '].includes(event.key)) return;
            document.dir === 'rtl' ? flkty.next() : flkty.previous();
          });
        });

        next_buttons.forEach(function (next_button) {
          next_button.addEventListener('click', () => {
            document.dir === 'rtl' ? flkty.previous() : flkty.next();
          });
          next_button.addEventListener('keyup', (event) => {
            if (next_button.tagName === 'BUTTON' || !['Enter', ' '].includes(event.key)) return;
            document.dir === 'rtl' ? flkty.previous() : flkty.next();
          });
        });
      }

      // Theme editor
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          if (index > -1) flkty.select(index);
        });
      }

      this.addEventListener('change', this.reInit.bind(this));
    }

    disconnectedCallback() {
      this.cleanupRecommendationAccessibility?.();
      this.cleanupBannerDots?.();
      this.cleanupAnnouncementPlayback?.();
      window.removeEventListener('scroll', this.handleScrollTheme);
      this._scrollThemeBound = false;
    }

    reInit() {
      if (this.flkty && typeof this.flkty.reloadCells === 'function') {
        this.flkty.reloadCells();
        this.flkty.resize();
      }
    }

    bindHeaderThemeScroll() {
      if (this._scrollThemeBound) return;
      window.addEventListener('scroll', this.handleScrollTheme, { passive: true });
      this._scrollThemeBound = true;
    }

    handleScrollTheme() {
      if (!this.flkty || !this.flkty.selectedElement) return;
      this.updateHeaderTheme(this.flkty.selectedElement);
    }

    updateHeaderTheme(currentSlide) {
  const header = document.querySelector('theme-header');
  if (!header || !currentSlide) return;

  document.body.classList.remove('slide-theme-dark', 'slide-theme-light');
  header.removeAttribute('data-slide-theme');

  if (currentSlide.classList.contains('slide--dark')) {
    document.body.classList.add('slide-theme-dark');
    header.setAttribute('data-slide-theme', 'dark');
    header.style.setProperty('--color-header-transparent-text', '#ffffff');
  } else if (currentSlide.classList.contains('slide--light')) {
    document.body.classList.add('slide-theme-light');
    header.setAttribute('data-slide-theme', 'light');
    header.style.setProperty('--color-header-transparent-text', '#000000');
  } else {
    header.style.removeProperty('--color-header-transparent-text');
  }
}

    resetHeaderTheme() {
      const header = document.querySelector('theme-header');
      if (!header) return;

      document.body.classList.remove('slide-theme-dark', 'slide-theme-light');
      header.removeAttribute('data-slide-theme');
      header.style.removeProperty('--color-header-transparent-text');
    }

    setupAutoplayProgress(slideshow, autoplay_progress) {
      slideshow.autoPlayProgressTL = gsap.timeline({
        inherit: false
      });

      slideshow.autoPlayProgressTL.fromTo(
        autoplay_progress,
        {
          scaleX: 0
        },
        {
          duration: parseInt(slideshow.dataset.autoplay, 10) / 1000,
          scaleX: 1,
          ease: 'linear'
        }
      );

      slideshow.addEventListener('mouseenter', function () {
        slideshow.autoPlayProgressTL.pause().progress(0);
      });

      slideshow.addEventListener('mouseleave', function () {
        slideshow.autoPlayProgressTL.play();
      });
    }

    videoPause(video_container) {
      setTimeout(() => {
        const video = video_container.querySelector('video');
        if (video) video.pause();
      }, 10);
    }

    videoPlay(video_container) {
      setTimeout(() => {
        const video = video_container.querySelector('video');
        if (video) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      }, 10);
    }

    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        new SplitText(slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)'), {
          type: 'lines',
          linesClass: 'line-child'
        });

        new SplitText(slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)'), {
          type: 'lines',
          linesClass: 'line-parent'
        });

        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({ paused: true }),
            button_offset = 0;

          animations[i] = tl;

          if (slideshow.dataset.transition == 'swipe') {
            tl.to(
              item,
              {
                duration: 0.7,
                clipPath: 'polygon(100% 0, 0 0, 0 100%, 100% 100%)'
              },
              'start'
            );
          }

          if (slideshow.dataset.transition == 'zoom') {
            tl.to(
              item.querySelectorAll('.slideshow__slide-bg, .slideshow__slide-video-bg'),
              {
                duration: 1.5,
                scale: 1
              },
              'start'
            );
          }

          if (item.querySelector('.subheading')) {
            tl.fromTo(
              item.querySelector('.subheading'),
              { opacity: 0 },
              { duration: 0.5, opacity: 1 },
              0
            );
            button_offset += 0.5;
          }

          if (item.querySelector('.slideshow__slide-heading')) {
            let h1_duration =
              1 + ((item.querySelectorAll('.slideshow__slide-heading .line-child').length - 1) * 0.1);

            tl
              .set(item.querySelectorAll('.slideshow__slide-heading'), { opacity: 1 }, 0)
              .from(
                item.querySelectorAll('.slideshow__slide-heading .line-child'),
                {
                  duration: h1_duration,
                  yPercent: 120,
                  stagger: 0.1
                },
                0
              );

            button_offset += h1_duration;
          }

          if (item.querySelector('p.split-text')) {
            let p_duration =
              1 + ((item.querySelectorAll('p.split-text .line-child').length - 1) * 0.05);

            tl
              .set(item.querySelectorAll('p.split-text'), { opacity: 1 }, 0)
              .from(
                item.querySelectorAll('p:not(.subheading) .line-child'),
                {
                  duration: p_duration,
                  yPercent: '120',
                  stagger: 0.1
                },
                0
              );

            button_offset += p_duration;
          }

          if (item.querySelectorAll('.button, .text-button').length) {
            tl.fromTo(
              item.querySelectorAll('.button, .text-button'),
              { autoAlpha: 0 },
              {
                duration: 0.5,
                stagger: 0.1,
                autoAlpha: 1
              },
              button_offset * 0.2
            );
          }

          item.dataset.timeline = tl;
        });

        slideshow.dataset.animationsReady = true;
      }
    }

    animateSlides(i, slideshow, animations) {
      if (!animations[i]) return;

      document.fonts.ready.then(function () {
        animations[i].restart();
      });
    }

    animateReverse(i, slideshow, animations) {
      if (!animations[i]) return;
      animations[i].reverse();
    }

    centerArrows(flickity, slideshow, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,
        image_height = 0;

      if (!first_cell) return;

      if (first_cell.element.querySelector('.product-featured-image')) {
        image_height = first_cell.element.querySelector('.product-featured-image').clientHeight;
      } else if (
        first_cell.element.querySelector('.gallery--item') &&
        flickity.cells[1]?.element.querySelector('.product-featured-image')
      ) {
        image_height = flickity.cells[1].element.querySelector('.product-featured-image').clientHeight;
      }

      if (image_height > 0) {
        flickity.cells.forEach((item) => {
          if (item.size.height > max_height) {
            max_height = item.size.height;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;
          prev_button.style.transform = 'translateY(' + difference + 'px)';
          next_button.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }

  customElements.define('slide-show', SlideShow);
}
